import React from 'react';
import classNames from 'classnames';

import styles from './TopBar.module.scss';

export interface TopBarPropsI {
  children?: React.ReactNode;
  underline?: boolean;
  sideDrawerOpen?: boolean;
}

const TopBar = ({ children, underline, sideDrawerOpen }: TopBarPropsI): JSX.Element => {
  return (
    <>
      <div className={styles.spacer}></div>
      <div
        id="tutorial-topbar"
        className={classNames(styles.TopBar, {
          [styles.TopBar_underline]: underline,
          [styles.TopBar_open]: sideDrawerOpen
        })}
      >
        {children}
      </div>
    </>
  );
};

export interface TopBarHeadingPropsI {
  children: React.ReactNode;
  onClick?: () => void;
}

const TopBarHeading: React.FC<TopBarHeadingPropsI> = (props: TopBarHeadingPropsI) => {
  return (
    <div className={styles.TopBar__heading}>
      {props.children}
    </div>
  );
};

export interface TopBarMiddlePropsI {
  children: React.ReactNode;
  width?: string;
}

const TopBarMiddle: React.FC<TopBarMiddlePropsI> = ({ children, width }) => {
  return (
    <div className={styles.TopBar__middle} style={{ width }}>
      {children}
    </div>
  );
};

export interface TopBarRightPropsI {
  children: React.ReactNode;
  width?: string;
}

const TopBarRight: React.FC<TopBarRightPropsI> = ({ children, width }) => {
  return(
    <div className={styles.TopBar__right} style={{ width }}>
      {children}
    </div>
  );
}

TopBar.Heading = TopBarHeading;
TopBar.Middle = TopBarMiddle;
TopBar.Right = TopBarRight;

export default TopBar;
